<div class="flex flex-col gap-4">
  <ng-container *ngIf="questions">
    <div
      *ngFor="let question of questions; let i = index"
      class="flex flex-col gap-3 p-4 border border-surface-200 dark:border-surface-700 rounded-lg">
      <div class="flex flex-col gap-2">
        <div class="flex flex-row items-center gap-3">
          <label class="font-semibold">
            {{ 'Question ' + (i + 1) }}
          </label>
          <p-tag
            *ngIf="question.typeDemande"
            [value]="getTypeLabel(question.typeDemande)"
            [severity]="getTypeSeverity(question.typeDemande)">
          </p-tag>
        </div>
        <div *ngIf="question.raisonSociale" class="text-sm text-surface-500 dark:text-surface-400 font-medium">
          {{ question.raisonSociale }}
        </div>
      </div>
      <div class="text-sm text-surface-600 dark:text-surface-400" [innerHTML]="question.question"></div>
      <div *ngIf="question.answer" class="mt-2 p-2 bg-surface-50 dark:bg-surface-800 rounded text-sm">
        <strong>{{ 'clarification.form.current_answer' | translate }}:</strong>
        <div [innerHTML]="question.answer"></div>
      </div>
    </div>
  </ng-container>
</div>
